module.exports = __webpack_public_path__ + "static/Gilroy-Bold-889a4b5ce3a780faedb74390fc49a07a.ttf";